import {useState} from 'react';

import {uploadImage} from '@/api/image';
import {useBooleanState} from '@/hooks/useBooleanState';
import {pickImage} from '@/utils/imagePicker/imagePicker';
import {IPickedImage} from '@/utils/imagePicker/types';

interface IProps {
  maxSize?: number;
  minSize?: number;
  circular?: boolean;
}

export interface IImageUploaderResult {
  pickedImage: IPickedImage | undefined;
  sizeError: boolean;
  uploadProgress: number;
  isUploading: boolean;
  selectImage: () => void;
  ipfsHash: string | undefined;
}

export const useImageUploader = ({
  maxSize,
  minSize,
  circular,
}: IProps): IImageUploaderResult => {
  const [pickedImage, setPickedImage] = useState<IPickedImage>();
  const [sizeError, setSizeError, clearSizeError] = useBooleanState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, uploadStarted, uploadEnded] = useBooleanState(false);
  const [ipfsHash, setIpfsHash] = useState<string>();

  const selectImage = async () => {
    try {
      clearSizeError();

      const asset = await pickImage({
        resizeHeight: maxSize,
        resizeWidth: maxSize,
        circular,
      });

      if (minSize && (asset.width < minSize || asset.height < minSize)) {
        setSizeError();
        return;
      }

      setPickedImage(asset);
      upload(asset);
    } catch (error) {}
  };

  const upload = async (image: IPickedImage) => {
    try {
      uploadStarted();
      setUploadProgress(0);
      const _ipfsHash = await uploadImage(image.file, setUploadProgress);
      setIpfsHash(_ipfsHash);
    } catch (error) {
      console.log(error);
    } finally {
      uploadEnded();
    }
  };

  return {
    pickedImage,
    sizeError,
    uploadProgress,
    isUploading,
    ipfsHash,
    selectImage,
  };
};
